<ng-container *ngIf="contact">
    <a [routerLink]="['/', contact.org_id, routeNames.CONTACTS, routeNames.CONTACT , contact.id]"
        class="contact ym-display-block ym-text-decoration-none ym-focus--focus ym-px-5 ym-py-3 ym-active-shadow-button-inset ym-transition-duration-medium">
        <div class="info-wrapper ym-display-flex ym-align-items-center ym-gap-3">
            <ym-avatar [size]="avatarSizes.LG" [name]="displayName"></ym-avatar>
            <div class="info ym-display-flex ym-flex-direction-column ym-w-full ym-gap-1 ym-overflow-hidden">
                <h3 class="ym-font-lg ym-font-weight-semibold ym-line-height-20 ym-text-color">{{
                    displayName }} </h3>
                <p class="ym-display-flex ym-text-secondary ym-gap-2 ym-align-items-center ym-font-sm">
                    <span
                        class="contact-detail ym-line-height-normal ym-white-space-nowrap ym-overflow-hidden ym-max-w-full ym-text-overflow-ellipsis"
                        *ngIf="description">{{ description }}
                        <!-- <span
                                            class="separator ym-w-2 ym-h-2 ym-mb-1 ym-display-inline-block ym-rounded-5 ym-bg-gray-50 ym-ml-1 ym-flex-shrink-0"></span> -->
                        <span class="separator ym-text-gray-100 ym-line-height-normal ym-ml-1 ym-font-lg"
                            *ngIf="description">•</span>
                    </span>
                    <span class="time ym-line-height-normal ym-white-space-nowrap"
                        [title]="'Last updated on: '+(contact.updated_on| dateTime: dateTimeFormats.LONG)">
                        {{contact.updated_on| dateTime: dateTimeFormats.RELATIVE}}
                    </span>
                </p>
            </div>
            <!-- <ym-button [icon]="iconNames.ELLIPSIS" [variant]="buttonVariants.ICON_ONLY"></ym-button> -->
        </div>
    </a>
</ng-container>